/** Full calendar year (Jan–Dec): sorts above quarter claims in the same year. */
const isAnnualPeriodClaim = (claim) =>
  Number(claim.startMonth) === 1 && Number(claim.endMonth) === 12;

/** Newest year first; within a year, annual (1–12) before quarters; then end/start month descending. */
export const sortClaimsByNewestPeriod = (claims) => {
  return [...claims].sort((a, b) => {
    const yearA = Number(a.year);
    const yearB = Number(b.year);
    if (yearB !== yearA) {
      return yearB - yearA;
    }

    const aAnnual = isAnnualPeriodClaim(a);
    const bAnnual = isAnnualPeriodClaim(b);
    if (aAnnual !== bAnnual) {
      return aAnnual ? -1 : 1;
    }

    const endA = Number(a.endMonth);
    const endB = Number(b.endMonth);
    if (endB !== endA) {
      return endB - endA;
    }

    const startA = Number(a.startMonth);
    const startB = Number(b.startMonth);
    if (startB !== startA) {
      return startB - startA;
    }

    return 0;
  });
};
